<template>
  <ModalBackdrop :show="!!modalAlertMessage" :margin="''" :padding="'drop-shadow-lg'">
    <div class="flex flex-grow flex-col" data-cy="app-modal-message">
      <div class="py-4 px-6">
        <h2 class="text-xl font-poppins font-medium" data-cy="app-modal-message-title">{{ modalAlertMessage?.title }}</h2>
      </div>
      <div class="flex flex-col py-2 px-6 gap-y-4" data-cy="app-modal-message-body">
        {{ modalAlertMessage?.body }}
      </div>
      <div class="flex justify-end p-2">
        <button class="p-2 rounded-md hover:bg-sky-5c0" @click="modalAlertMessage?.btnAction" data-cy="app-modal-message-button">
          <span class="text-xl text-primary-blue"> {{ modalAlertMessage?.btnTxt }} </span>
        </button>
      </div>
    </div>
  </ModalBackdrop>
</template>

<script setup lang="ts">
import { AlertType, type AlertMessage, type ModalAlertMessage } from '@pi-xcels/utils';
import { computed } from 'vue';

const props = defineProps<{
  alertMessages: Readonly<AlertMessage[]>;
}>();

const modalAlertMessage = computed(() => props.alertMessages.filter((msg): msg is ModalAlertMessage => msg.type === AlertType.Modal).shift());
</script>
